import type React from 'react';
import { CreatePortfolioTemplate } from '../createModelPortfolio/components/createPortfolioTemplate';
import type { CreateAssetTemplateOptions } from './createAssetTemplate';

type CreateAssetTemplateVisualProps = {
  options: CreateAssetTemplateOptions;
  onComplete: () => void;
  loading: boolean;
};

export const CreateAssetTemplateVisual: React.FC<
  CreateAssetTemplateVisualProps
> = ({ options, onComplete, loading }) => {
  return (
    <CreatePortfolioTemplate
      options={options}
      loading={loading}
      onComplete={onComplete}
    />
  );
};
